export enum ActivityType {
  Win = 'WIN',
  Draw = 'DRAW',
  NewPlayer = 'NEW_PLAYER',
  ReferralReward = 'REFERRAL_REWARD',
}
